import { useCallback, useEffect, useState } from 'react';

// [secondsLeft, start(seconds)]: ticks once a second from a fixed end time (no drift), stops at 0.
const useCountdown = () => {
  const [endsAt, setEndsAt] = useState(null);
  const [left, setLeft] = useState(0);

  useEffect(() => {
    if (!endsAt) return undefined;
    const tick = () => {
      const s = Math.max(0, Math.ceil((endsAt - Date.now()) / 1000));
      setLeft(s);
      if (s === 0) setEndsAt(null);
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [endsAt]);

  const start = useCallback((seconds) => setEndsAt(Date.now() + Math.max(1, seconds) * 1000), []);
  return [left, start];
};

export default useCountdown;
